module.exports = __webpack_public_path__ + "img/section-3-content_1_t_icon9_native.44074525.png";